import React from "react";
import "./About_Us.css";
import Service_Banner from "../services/service_common_components/service_banner/Service_Banner";
import We_Shape from "./we_shape/We_Shape";
import Our_Team from "./our_team/Our_Team";
import Counter from "../home/counter/Counter";
import Vission_Mission from "./vission_mission/Vission_Mission";
import Our_Strength from "./our_strength/Our_Strength";
import Portfolio from "./portfolio/Portfolio";

const About_Us = () => {
  return (
    <section className="About_Us">
      <Service_Banner
        imgSrc={"/assets/images/about_us/banner/banner.png"}
        title_text={"ABOUT US"}
      />
      <We_Shape />

      <Our_Strength />
      <Portfolio />

      {/* <Our_Team /> */}
      <Counter />
      <Vission_Mission />
    </section>
  );
};

export default About_Us;
